
LocaleValues.$inject = ['$scope', '__env', 'toastr', 'httpService', 'readCookie', '$q'];angular
    .module('app')
    .component('localeValuesComponent', {
        templateUrl: 'modules/localization/components/localevalues/localeValues.html',
        controller: LocaleValues
    });

/**
 * Code supporting the kendo grid that displays LocaleSections
 * and performs CRUD opperations
 *
 * @class Locales
 * @param { service } $scope - The scope of the component.
 * @param { service } __env - The environment configuration.
 * @param { service } toastr - The third party toaster service.
 * @param { service } httpService - The http service used to make asynchronous rest calls
 * @param { service } readCookie - reads cookie variables
 */
function LocaleValues($scope, __env, toastr, httpService, readCookie, $q) {

    // columns of the grid
    var columns = [
        {
            field: 'localeCode',
            title: 'Locale Code',
            width: '12%',
        },
        {
            field: 'sectionCode',
            title: 'Section Code',
            width: '13%',
        },
        {
            field: 'fieldCode',
            title: 'Field Code',
            width: '17%',
        },
        {
            field: 'value',
            title: 'Value',
            width: '40%',
        },
        {
            command: ['edit',  { text: 'Delete', click: deleteItem, template: "<a class='k-button k-button-icontext k-grid-Delete' href='\\#' ><span class=''></span>Delete</a>" }],
            title: '&nbsp;',
            width: '16%',
        }
    ];

    var model = {
        fields: {
                localeId: { type:'number', defaultValue: null},
                sectionId: { type:'number', defaultValue: null},
                fieldId: { type:'number', defaultValue: null},
                value: { type:'string' },
              }
    };


    $scope.pageTitle = 'Locale Values';

    $scope.localeValuesOptions = {
        columnMenu: false,
        columns: columns,
        editable: {
            mode: 'popup',
            template: kendo.template($('#localeValueEditGridTemplate').html())
        },
        edit: function (e)
        {
            var editWindow = this.editable.element.data('kendoWindow');
            editWindow.wrapper.css({ width: 460 });
        },
        filterable: {
            extra: false,
            operators: {
                string: {
                    contains: 'Contains',
                    eq: 'Is equal to'
                }
            }
        },
        groupable: false,
        pageable: true,
        save: saveEvent,
        cancel: function(e) {
            e.preventDefault();
            $scope.localeValuesGrid.cancelChanges();

            $scope.isAdd = false;
          },
        scrollable: true,
        sortable: true
    };

        /**
     * Sets up http request to get locale sections to use with grid edits.
     * On success, loads the sections array. Uses a promise to ensure
     * the sections are loaded before the grid.
     *
     * @function
     */
    $scope.getLocales = function() {

        // wait for the types to resolve
        return $q(function(resolve, reject) {

            var url = __env.apiBaseUrlLocalization + '/locales';
            var type = 'get';
            var data = '';


            httpService.asyncCall(url, type, data)
                .then(function(response) {
                        $scope.locales = response.data;
                        $scope.drpLocaleOptions.dataSource.read();
                        resolve(true);

                }).catch(function(e){
                    toastr.error('Did not get locales');
                    reject(false);
                });

        });
    };

            /**
     * Sets up http request to get locale sections to use with grid edits.
     * On success, loads the sections array. Uses a promise to ensure
     * the sections are loaded before the grid.
     *
     * @function
     */
    $scope.getSections = function() {

        // wait for the types to resolve
        return $q(function(resolve, reject) {

            var url = __env.apiBaseUrlLocalization + '/localesections';
            var type = 'get';
            var data = '';


            httpService.asyncCall(url, type, data)
                .then(function(response) {
                    $scope.sections = response.data;
                    $scope.drpSectionOptions.dataSource.read();
                    resolve(true);
                }).catch(function(e){
                    toastr.error('Did not get locale sections');
                    reject(false);
                });

        });
    };

    /**
     * Triggers the new row add for a kendo grid.
     *
     * @function addNewLocaleValue
     */
    $scope.addNewLocaleValue = function() {

        // trigger the add event
        this.localeValuesGrid.addRow();
        $scope.selectedSectionId = null;
        $scope.drpFieldOptions.dataSource.read();

        $scope.isAdd = true;
    };

    /**
     * Prepares the http request for adding a new locale. Handles callbacks
     *
     * @function
     * @param { object } locale - locale to be added
     */
    $scope.addLocaleValue = function(localeValue) {
        var url =  __env.apiBaseUrlLocalization + '/localevalues';
        var type = 'post';
        var data = localeValue;

        httpService.asyncCall(url, type, data)
            .then(function(response) {
                $scope.localeValuesGrid.refresh();
                toastr.success('Locale value successfully added');

            }).catch(function(e){
                $scope.localeValuesGrid.cancelChanges();
                toastr.error('The Locale value could not be added');

            });
    };

    var deleteLocaleValueTemplate = kendo.template($('#deleteLocaleValueTemplate').html());
    var deleteLocaleValueWindow = $('#deleteLocaleValueWindow').kendoWindow({
        title: 'Are you sure you want to delete this record?',
        visible: false, //the window will not appear before its .open method is called
        width: '370px',
        height: '140px',
        modal: true
    }).data('kendoWindow');


    /**
     * Prepares the http request for deleting a locale. Handles callbacks
     *
     * @function
     * @param { object } locale - locale to be deleted
     */
    $scope.deleteLocaleValue = function(localeValue) {

        var url = __env.apiBaseUrlLocalization + '/localevalues/' + localeValue.localeId + '/' + localeValue.fieldId;
        var type = 'delete';
        var data = '';

        httpService.asyncCall(url, type, data)
            .then(function(response) {
                $scope.localeValuesGrid.dataSource.remove(localeValue);
                deleteLocaleValueWindow.close();
                toastr.success('Locale value successfully deleted');
            }).catch(function(e){
                deleteLocaleValueWindow.close();
                toastr.error('The Locale value could not be deleted');
            });
    };

    /**
     * handles delete for the locale grid.
     *
     * @function
     * @param { event } e - delete row event
     */
    function deleteItem(e) {
        e.preventDefault();
        var dataItem = this.dataItem($(e.currentTarget).closest('tr'));
        deleteLocaleValueWindow.content(deleteLocaleValueTemplate(dataItem)); //send the row data object to the template and render it
        deleteLocaleValueWindow.center().open();

        $('#deleteLocaleValueWindow #btnOk').click(function(){
            $scope.deleteLocaleValue(dataItem);
        });

        $('#deleteLocaleValueWindow #btnCancel').click(function(){
            deleteLocaleValueWindow.close();
        });
    }

    /**
     * handles save event for the locale value grid.
     *
     * @function
     * @param { event } e - save row event
     */
    function saveEvent(e) {

        $scope.displayMode = true;

        // stop kendo from being annoying
        e.preventDefault();

        var isAdd = (e.model.localeCode == undefined || e.model.sectionCode == undefined || e.model.fieldCode == undefined);

        if(isAdd) {
            //update the codes only when adding from the dropdowns as they dont get bind
            e.model.localeCode =  angular.element(document).find('#drpLocale').data('kendoDropDownList').text();
            e.model.sectionCode = angular.element(document).find('#drpSection').data('kendoDropDownList').text();
            e.model.fieldCode = angular.element(document).find('#drpField').data('kendoDropDownList').text();

            //update the value of drps
            e.model.localeId =  angular.element(document).find('#drpLocale').data('kendoDropDownList').value();
            e.model.sectionId = angular.element(document).find('#drpSection').data('kendoDropDownList').value();
            e.model.fieldId = angular.element(document).find('#drpField').data('kendoDropDownList').value();

            // locales without an id should be added
            $scope.addLocaleValue(e.model);
        } else {
            // locales value with an id should be updated
            $scope.updateLocaleValue(e.model);
        }

        $scope.isAdd = false;
    }

    /**
     * Prepares the http request for updating a locale value. Handles callbacks.
     *
     * @function
     * @param { obj } locale Value - locale object
     */
    $scope.updateLocaleValue = function(localeValue) {
        var url = __env.apiBaseUrlLocalization + '/localevalues/' + localeValue.localeId + '/' + localeValue.fieldId;
        var type = 'put';
        var data = localeValue;

        httpService.asyncCall(url, type, data)
            .then(function(response) {
                $scope.localeValuesGrid.refresh();
                toastr.success('Locale value successfully updated');
            }).catch(function(e){
                $scope.localeValuesGrid.cancelChanges();
                toastr.error('The Locale value could not be updated');
            });

    };

    //initially not in add mode
    $scope.isAdd = false;

    $scope.locales = {};
    $scope.sections = {};
    $scope.fields = {};

    $scope.drpLocaleOptions = {
        dataTextField: 'code',
        dataValueField: 'localeId',
        valuePrimitive: true,
        dataSource: new kendo.data.DataSource({
            transport: {
                read: function(options) {
                    options.success($scope.locales);
                }
            }
        }),
        optionLabel: { code: 'Select locale...', localeId: '' },
        filter: 'startswith'
    };

    $scope.drpSectionOptions = {
        dataTextField: 'sectionCode',
        dataValueField: 'sectionId',
        valuePrimitive: true,
        dataSource: new kendo.data.DataSource({
            transport: {
                read: function(options) {
                    options.success($scope.sections);
                }
            }
        }),
        optionLabel: { sectionCode: 'Select section...', sectionId: '' },
        filter: 'startswith',
        change: function(e) {
                    $scope.selectedSectionId = this.value();
                    $scope.drpFieldOptions.dataSource.read();
                }
    };

    $scope.drpFieldOptions = {
        autoBind: false,
        dataTextField: 'fieldCode',
        dataValueField: 'fieldId',
        valuePrimitive: true,
        dataSource: new kendo.data.DataSource({
            transport: {
                      read: function(options) {
                          if($scope.selectedSectionId == null)
                          {
                              options.success([]);
                              return;
                          }
                          var url = __env.apiBaseUrlLocalization + '/localefields/section/' + $scope.selectedSectionId;
                        httpService.asyncCall(url, 'get')
                            .then(function(response) {
                                options.success(response.data);
                            }).catch(function(e){
                                toastr.error('Could not get locale fields');
                            });
                      }
                    }
        }),
        optionLabel: {fieldCode: 'Select field...', fieldId: ''},
        filter: 'startswith'
    };



     /**
     * Runs first on page load and loads required data.
     *
     * @function
     */
    $scope.init = function(){

        var promises = [];
        promises.push($scope.getLocales());
        promises.push($scope.getSections());

        //wait for all promises to finish before assigning kendo data source variable which will render the grid.
        $q.all(promises).then(function(){
            //only assign the localeValueSource once all promises finishes as the kendo grid has ng-delay on this variable.
            $scope.localeValuesSource =
            {
                type: 'aspnetmvc-ajax',
                error: function(e) { toastr.error('Could not get locale values');},
                transport: {
                        read: {
                                type: 'get',
                                contentType: 'application/json',
                                url: __env.apiBaseUrlLocalization + '/localevalues/paged/kendo',
                                beforeSend: function(req) {
                                           req.setRequestHeader('UserToken', readCookie.getByName(__env.sessionCookieName));
                                       },
                            }

                },
                schema: {
                    data: 'data',
                    total: 'total',
                    model: model,
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            };
        });



    };

    $scope.init();
}